<div class="ourWbSec">
    <app-login-header></app-login-header>
    <div class="iframeSec">
      <iframe #iframe id="Iframe"  class="iframe" [src]="iframeUrl" target="_parent"  title="ourweb"></iframe>
    </div>
</div>
